import React, { useContext } from 'react'
import { mapHazardousTranslations } from '../../selectors/translations'
import Attributes from './Attributes'
import Phytopharma from './Phytopharma'
import HazardousBlock from './HazardousBlock/HazardousBlock'
import { getProductAdditionalEans, getProductDescription, getProductGtin } from '../../../../common/selectors/product'
import { clsx } from 'clsx'
import { Heading } from 'chemistry'
import Ean from 'client/fragments/productDetailsFragmentInfo/components/Ean'
import { TranslateContext } from 'client/common/translator'

const Description = ({ lang, productDetails, pimAttributesTranslations }) => {
  const t = useContext(TranslateContext)
  const ean = getProductGtin(productDetails)
  const additionalEans = getProductAdditionalEans(productDetails)
  const description = getProductDescription(productDetails)
  const hazardTranslations = mapHazardousTranslations(t)

  return (
    <section className={clsx('mxd-fragment-description-root')} id='specs'>
      <div className='mxd-description-container'>
        <Heading size='md'>{t('product_description_header')}</Heading>
        <div dangerouslySetInnerHTML={{ __html: description }} />
        <Ean ean={ean} additionalEans={additionalEans} />
      </div>
      <HazardousBlock hazardInfo={productDetails.hazardInfo} translationMapping={hazardTranslations} />
      <Attributes productDetails={productDetails} lang={lang} pimAttributesTranslations={pimAttributesTranslations} />
      {!!productDetails.phytopharma && <Phytopharma lang={lang} />}
    </section>
  )
}

export default Description
